export default __webpack_public_path__ + "static/media/crypto-logo.f47dfeee.jpg";